import React from 'react';
import Button from '@dtci/spellbook/Button';

export default function NameCellRenderer(props) {
    const handleEdit = () => {
        props.api.startEditingCell({
            rowIndex: props.rowIndex,
            colKey: props.column.colId
        });
    };

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
                style={{
                    marginLeft: 6,
                    userSelect: 'none',
                    display: 'flex',
                    alignItems: 'center'
                }}
                iconType="fa-solid fa-pencil"
                sizeType="small"
                styleType="link"
                onClick={handleEdit}
            />
            {props.value}
        </span>
    );
}